import { render, staticRenderFns } from "./ModelBreak.vue?vue&type=template&id=b2ba26e6&scoped=true"
import script from "./ModelBreak.vue?vue&type=script&lang=js"
export * from "./ModelBreak.vue?vue&type=script&lang=js"
import style0 from "./ModelBreak.vue?vue&type=style&index=0&id=b2ba26e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ba26e6",
  null
  
)

export default component.exports